export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[var(--ink)] text-[var(--bone)]">
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif-display text-2xl md:text-3xl tracking-tight flex items-baseline gap-2">
              <span>Co‑Own</span>
              <span className="font-bold not-italic" style={{ color: "#E87A4C" }}>Israel</span>
            </div>
            <p className="mt-4 max-w-md text-[var(--bone)]/65 font-light text-sm leading-relaxed">
              Your home in Israel. Shared wisely. Managed completely. A curated, legally
              structured fractional ownership path for Jewish families abroad.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-overline text-[var(--gold)] mb-4">Serving families in</div>
            <ul className="space-y-2 text-[var(--bone)]/80 text-sm font-light">
              <li>Australia</li>
              <li>United Kingdom</li>
              <li>France</li>
              <li>Canada</li>
              <li>United States</li>
              <li>South Africa</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-overline text-[var(--gold)] mb-4">Get in touch</div>
            <a
              data-testid="footer-email"
              href="mailto:stan@co-ownisrael.com"
              className="block text-[var(--bone)]/90 hover:text-[var(--gold)] transition-colors text-sm"
            >
              stan@co-ownisrael.com
            </a>
            <a
              data-testid="footer-register-link"
              href="#register"
              className="mt-4 inline-block text-sm border-b border-[var(--gold)]/70 pb-0.5 hover:text-[var(--gold)] transition-colors"
            >
              Register your interest →
            </a>
            <a
              data-testid="footer-refer-link"
              href="#refer"
              className="mt-4 ml-5 inline-block text-sm border-b border-[var(--gold)]/40 pb-0.5 text-[var(--bone)]/75 hover:text-[var(--gold)] transition-colors"
            >
              Refer a family →
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[var(--bone)]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[var(--bone)]/55">
          <div>© {new Date().getFullYear()} Co‑Own Israel. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a
              data-testid="footer-privacy-link"
              href="/privacy"
              className="hover:text-[var(--gold)] transition-colors"
            >
              Privacy notice
            </a>
            <span className="font-light">Private &amp; confidential — for invited families only.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
